import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'

export default function Activepolicies() {
    const [search, setSearch] = useState('');
    const [startDate, setStartdate] = useState('');
    const [endDate, setEnddate] = useState('');
    const [policies, setPolicies] = useState([])
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedProposal, setSelectedproposal] = useState('');
    const [productName, setProductname] = useState('');
    const [productCode, setProductcode] = useState('')
    const [policyNumber, setPolicynumber] = useState('');
    const [client, setClient] = useState('');
    const [clientCode, setClientcode] = useState('')
    const [coverPeriod, setCoverperiod] = useState('');
    const [commence, setCommence] = useState('');
    const [commence1, setCommence1] = useState('');
    const [expiry, setExpiry] = useState('');
    const [expiry1, setExpiry1] = useState('');
    const [insuredItemcode, setInsureitemcode] = useState('');
    const [insuredItemname, setInsureditemname] = useState('');
    const [premiumAmount, setPremiumamount] = useState(0);
    const [reg, setReg] = useState('');
    const [makeCode, setmakeCode] = useState('')
    const [makeName, setMakename] = useState('')
    const [modelCode,setModelcode] = useState('')
    const [color, setColor] = useState('')
    const [yom, setYom] = useState('')
    const [tonnage, setTonnage] = useState('')
    const [chassis, setChassis] = useState('')
    const [engine, setEngine] = useState('')
    const [capacity, setCapacity] = useState('')
    const [sumInsured, setSuminsured] = useState(0)
    const [certUrl, setCerturl] = useState('')
    const [cc,setCC] = useState('')
    const [insuredItem, setInsureditem] = useState('')
    const [proposalNo, setProposalno] = useState('')
    const [dateDone, setDatedone] = useState('')
    const [commission, setCommission] = useState(0)
    const [modal, setModal] = useState(false)
    const [modal2, setModal2] = useState(false)
    const [selectedOption, setSelectedOption] = useState('GROSS');
    const [payAmount, setPaymount] = useState(0)
    const [mobile, setMobile] = useState('')
    const [optionCode, setOptioncode] = useState('')
    const [optionName, setOptionname] = useState('')
    const [isCert, setIscert] = useState(0)
    const [certURL, setCertURL] = useState('')
    const [today, setToday] = useState('')
    const [PHCF, setPHCF] = useState('')
    const [netCommission,setNetcommission] = useState('')
    const [trainingLevy, setTraininglevy] = useState('')
    const [whtax, setWhtax] = useState('')
    const [extensionStartdate, setExtensionstartdate] = useState(null)
    const [extesnionExpirydate, setExtensionexpirydate] = useState(null)
    const [commissionRate, setCommissionrate] = useState('')
    const rowsPerPage = 20;
    const [netPremium, setNetpremium] = useState('')
    const totalPages = Math.ceil(policies.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = policies.slice(indexOfFirstRow, indexOfLastRow)
    const [extendText, setExtendtext] = useState('EXTEND POLICY')
    const [insuredOID, setInsuredOID] = useState('')
    const [bodyType, setBodytype] = useState('')
    const [commencementDate, setCommencementDate] = useState('')
    const [expiryDate, setExpirydate] = useState('')
    const [clientEmail, setClientemail] = useState('');
    const [clientPin, setClientpin] = useState('')
    const [iraCode, setIracode] = useState('')
    const [iraNumber, setIranumber] = useState('')
    const [eMessage,setEmessage] = useState('')
    const [commencementUnix, setCommencementunix] = useState(null)
    const [expiryUnix, setExpiryunix] = useState(null)
    const [commencement, setCommencement] = useState(null)
    const [numberOfDays, setNumberOfDays] = useState(0);
    const [premium,setPremium] = useState(0)
    const [basicPremium, setBasicpremium] = useState(0);
    const [coverDays, setCoverdays] = useState('')
    const [quoteText, setQuotetext] = useState('Calculate Premium')
    const [stampduty, setStampduty] = useState(0)
    const [isCalculated, setIscalculated] = useState(false)
    const [paymentMode, setPaymentmode] = useState(0)
    const [walletBallance, setWalletbalance] = useState(0)
    const [walletNo, setWalletno] = useState('')
    const [dataLoaded, setDataloaded] = useState(0)
    const [isMpesa, setIsmpesa] = useState(true)
    const [utilize, setUtilize] = useState(0)
    const [availableCommission, setAvailablecommission] = useState(0)
    const [comm2, setComm2] = useState(0)
    const [nc2, setNc2] = useState(0)
    const [clientPhone, setClientphone] = useState('')
    const [promptID, setPromptid] = useState(0)
    const [modal3, setModal3] = useState(false)
    const [mpesaCode, setMpesacode] = useState('')
    const [checkMpesa, setCheckmpesa] = useState(false)
    const [verifyText, setVerifytext] = useState('VERIFY')
    const [agentName,setAgentname] = useState('')
    const [prdCode, setPrdcode] = useState('');
    const [insuredSchedule, setInsuredSchedule] = useState('')
    const [dealerCode,setDealercode] = useState('')
    const [isActive, setIsactive] = useState(0)
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const [retryText, setRetrytext] = useState('Retry')
    const company = 'Definite'
    const [ext,setExt] = useState(null)
    const [cmm,setCmm] = useState(null)
    const [doubleInsurancestatus, setDoubleinsurancestatus] = useState(false)
    const [doubleinsuranceMessage, setDoubleinsuracemessage] = useState('')
    const [checkingStatus, setCheckingstatus] = useState(0)
    const [transactionId, setTransactionId] = useState(null)

    useEffect(()=>{
    const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


    }
    getCredentials()

    },[])
    


    useEffect(() => {
        // Function to get days in current month
        const getDaysInCurrentMonth = () => {
            const now = new Date();
            // Get last day of current month by going to month+1 and day 0
            return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
        };
        
        const days = getDaysInCurrentMonth();
        setNumberOfDays(days);
        }, []);
  


    

    useEffect(() => {

    const user = localStorage.getItem('definiteagent'); // Retrieve email
    if (user) {
        
        setAgent(user)
    } else {
    
    }
    }, []);


    useEffect(()=>{
        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)   
            setAgentname(data.Dealer_name)
            setDealercode(data.Dealer_type)
             if(data.Approved){
                setIsactive(1)
            }
            else{
                setIsactive(0)
            }

        }
        const getIranumber =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getIranumber?agent=${agent}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json()
            setIranumber(data.IRANumber)
        }


        if(agent && isAuth){
            getAgentcode()
            getIranumber()
        }

    },[agent,isAuth])

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setStartdate(millisecondsSinceEpoch);
    }


    const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEnddate(millisecondsSinceEpoch);
    }

    useEffect(()=>{
        const getPolicies =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/Activepolicies?agentCode=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data  = await res.json();
            setPolicies(data)
        }

        const getWallet =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWallet?agent=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setWalletno(data.WalletNo)

        }
        const getCommission =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUtilizedCommission?agent=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            if(data.AvailableCommission == null){
                setAvailablecommission(0)
            }
            else{
                setAvailablecommission(data.AvailableCommission)
            }

            
        }
        if(agentCode && isAuth){
            getPolicies()
            getWallet()
            getCommission()
        }

    },[agentCode,isAuth])

    useEffect(()=>{
    const getWalletbalance =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletbalance?wallet=${walletNo}`,{
            method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
        const data = await res.json();
        setWalletbalance(data.Balance)
    }

    if(walletNo && isAuth){
        getWalletbalance()
    }

    },[walletNo,isAuth])

    function formateDateISO(input){
        if(typeof input === 'string'){
            return input.split('T')[0]
        }
        else if (input instanceof Date){
            return input.toISOString().split('T')[0]
        }

        throw new Error('Invalid input: Expected ISO String or Date Object')
    }

    function formatter(amount) {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }

    useEffect(()=>{

        const checkDoubleinsurance = async()=>{
                setCheckingstatus(1)

              const res = await Axios.post('https://sms.definiteassurance.com/webhook/d6c9608b-cd90-481a-995d-d40c908c96db',{
                        chasis:chassis,reg,commence:commencementDate,end:expiryDate
            })
             setCheckingstatus(2)

             if(res.data.success){
           
            setDoubleinsurancestatus(true)
            setDoubleinsuracemessage(`Vehicle has active certificate in ${res.data.company}. Expected expiry: ${res.data.endDate}`)
            // toast.error('Vehicle has double insurance')
            }
            else{
                setDoubleinsurancestatus(false)
                setDoubleinsuracemessage('No double insurance')
            }
             
        }

        if(commencementDate){
            checkDoubleinsurance()
        }

    },[commencementDate])

    const getDetails =async(e)=>{
        const oid = e.target.value;
        setSelectedproposal(oid)

        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getThisProposal?proposal=${oid}`,{
            method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
        
        const data = await res.json();
        setMakename(data.Description)
        setModelcode(data.ModelName)
        setCapacity(data.Capacity)
        setChassis(data.ChasisNumber)
        setEngine(data.EngineNo)
        setYom(data.YearOfManufacture)
        setSuminsured(data.SumInsured)
        setCC(data.CC)
        setClientphone(data.Mobile)
        setTonnage(data.Tonnage)
        setInsureditem(data.ItemName)
        setProductcode(data.Product)
        setProductname(data.ProductDescription)
        setClient(data.Dealer_name)
        setProposalno(data.ProposalNo)
        setCommence(data.CommencementDate)
        setCommence1(data.CommencementDate)
        setExpiry(data.ExpiryDate)
        setExpiry1(data.ExpiryDate)
        setExpirydate(data.ExpiryDate)
        setDatedone(data.DateDone)
        setCoverperiod(data.PeriodOfCover)
        setReg(data.Narration)
        setPremiumamount(data.GrossPremium)
        setPaymount(data.GrossPremium)
        // setCommission(data.GrossCommission)
        setPolicynumber(data.PolicyNo)
        setClientcode(data.Client)
        setWhtax(Math.round((data.GrossCommission)*0.1))
        setNetcommission(data.GrossCommission -(Math.round((data.GrossCommission)*0.1)) )
        setCommissionrate(data.CommissionRate)
        setPHCF(data.PHCF)
        // setNetcommission(Math.round(0.9*data.GrossCommission))
        setTraininglevy(data.TrainingLevy)
        setInsuredOID(data.insuredOID)
        setBodytype(data.BodyType)
        setClientemail(data.Email)
        setClientpin(data.Pin)
        setIracode(data.IRACode)
        setInsureitemcode(data.ProductInsuredItem)
        setDataloaded(1)
        if(data.coption == 1 || data.coption == 58){
            setOptioncode(100)
            setOptionname('COMP')
        }
        if(data.coption == 2){
            setOptioncode(200)
            setOptionname('TPO')
        }


        setModal(!modal)
        
        
        
    }

    const getDetails2 =async(e)=>{

        if(isActive == 1){
            if(dealerCode == 185 || dealerCode == 187){
                  const oid = e.target.value;
                    setSelectedproposal(oid)

                    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getThisProposal?proposal=${oid}`,{
                        method:"GET",
                        headers:{
                        'Authorization': `Basic ${credentials}`,
                        'Content-Type': "application/json"
                        }
                    })
                    const data = await res.json();
                    setMakename(data.Description)
                    setModelcode(data.ModelName)
                    setCapacity(data.Capacity)
                    setChassis(data.ChasisNumber)
                    setEngine(data.EngineNo)
                    setYom(data.YearOfManufacture)
                    setSuminsured(data.SumInsured)
                    setCC(data.CC)
                    setTonnage(data.Tonnage)
                    setInsureditem(data.ItemName)
                    setProductcode(data.Product)
                    setProductname(data.ProductDescription)
                    setClient(data.Dealer_name)
                    setClientphone(data.Mobile)
                    setProposalno(data.ProposalNo)
                    setCommence(data.CommencementDate)
                    setExpiry(data.ExpiryDate)
                    setExpirydate(data.ExpiryDate)
                    setDatedone(data.DateDone)
                    setCoverperiod(data.PeriodOfCover)
                    setReg(data.Narration)
                    setPremiumamount(data.GrossPremium)
                    setPaymount(data.GrossPremium)
                    setCommission(data.GrossCommission)
                    setPolicynumber(data.PolicyNo)
                    setClientcode(data.Client)
                    setWhtax(Math.round((data.GrossCommission)*0.1))
                    setNetcommission(data.GrossCommission -(Math.round((data.GrossCommission)*0.1)) )
                    setCommissionrate(data.CommissionRate)
                    setPHCF(data.PHCF)
                    setNetcommission(Math.round(0.9*data.GrossCommission))
                    setTraininglevy(data.TrainingLevy)
                    setInsuredOID(data.insuredOID)
                    setBodytype(data.BodyType)
                    setClientemail(data.Email)
                    setClientpin(data.Pin)
                    setIracode(data.IRACode)
                    setInsureitemcode(data.ProductInsuredItem)
                    if(data.coption == 1 || data.coption == 58){
                        setOptioncode(100)
                        setOptionname('COMP')
                    }
                    if(data.coption == 2){
                        setOptioncode(200)
                        setOptionname('TPO')
                    }


                    setModal2(!modal2)

            }
            else{
                toast.error('You need an agents account to extend!')
            }

        }
        else{
            toast.error('Your account is not approved')
        }



      
        
        
        
    }

    const cancelPolicy =async()=>{
        toast.error('DISABLED! PLEASE CHECK LATER')
    }


    function formatDate(milliseconds) {
        const date = new Date(milliseconds);
        
        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        
        // Format as YYYY-MM-DD HH:mm:ss.ms
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}`;
    }

    const handleDateChange3 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setCommencement(millisecondsSinceEpoch);
        setCommencementDate(formatDateFromMilliseconds(millisecondsSinceEpoch))
        setCommencementunix(formatDate(millisecondsSinceEpoch))
        const dt = Date.now().toString()
        var monthDuration;

        if(numberOfDays == 30){
            monthDuration = 2592000000-86400000;
        }
        else if(numberOfDays == 31){
            monthDuration = 2592000000;
        }

        else if(numberOfDays == 28){
            monthDuration =  2419200000 -86400000 ;
        }

        else if(numberOfDays == 29){
            monthDuration =  2419200000 ;
        }
        const weekDuration = 604800000-86400000;
       
        const fortnightDuration = 1209600000-86400000;
        const annualDuration = (31536000000-monthDuration)-(86400000*3);

        if(coverPeriod == 'Monthly' || coverPeriod == '3Installments' || coverPeriod == '6Installments' || coverPeriod == '10Installments'){
            const exp = millisecondsSinceEpoch+monthDuration;
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            
            setCoverdays(30)
            
        }
        else if(coverPeriod == 'Week'){
            const exp = millisecondsSinceEpoch + weekDuration;
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setCoverdays(7)
        }
        else if(coverPeriod == 'Fortnight'){
            const exp = millisecondsSinceEpoch + fortnightDuration
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setCoverdays(14)
        }
        else if(coverPeriod == 'Annually'){
            const exp = millisecondsSinceEpoch + annualDuration
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setCoverdays(335)
        }
        else if(coverPeriod == '2installments'){
            const exp = millisecondsSinceEpoch + annualDuration
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setCoverdays(333)
        }
      };

    // const handleDateChange3 = (e) => {
    //     const dateTime = e.target.value;
    //     const millisecondsSinceEpoch = new Date(dateTime).getTime();
    //     setExtensionstartdate(formatDate(millisecondsSinceEpoch));
    //     setCommencementDate(formatDateFromMilliseconds(millisecondsSinceEpoch))

    //     const date = new Date(extensionStartdate);


    //     const exp = date.setDate(date.getDate() + parseInt(coverPeriod) + 1)
    //     setExtensionexpirydate( formatDate(exp) )

    //     setExpirydate(formatExtensionExpiryDate(formatDate(exp)))
    //     // formatExtensionExpiryDate(extesnionExpirydate)

        
    //   };

      useEffect(()=>{
        const now = new Date();
        
        // Format YYYY-MM-DD
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        
        // Format HH:mm:ss.SSS
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        
        setToday(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`)

      },[])


      function getCurrentDateTimeFormatted() {
        const now = new Date();
        
        // Format YYYY-MM-DD
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        
        // Format HH:mm:ss.SSS
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
      }

      function formatDateFromMilliseconds(milliseconds) {
        const date = new Date(milliseconds);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        
        
        return `${day}/${month}/${year}`;
    }
    function formatExtensionExpiryDate(dateString) {
        // Split the date string into parts
        const parts = dateString.split(/[- :]/);
        
        // Extract year, month, and day
        // The year is in YY format, so we prepend '20' to get YYYY
        const year = '20' + parts[0];
        const month = parts[1];
        const day = parts[2];
        
        // Return in MM/DD/YYYY format
        return `${day}/${month}/${year}`;
    }


    const toggle =()=>{

        if(isActive == 1){
            if(dealerCode == 185 || dealerCode == 187){
                  const date = new Date(expiry);

                        // Add 1 day
                    const exp = date.setDate(date.getDate() + 1)
                    setExtensionstartdate( formatDate(exp) )

                    setModal(false)
                    setModal2(!modal2)
            }
            else{
              toast.error('Your need an agents account to proceed!')  
            }
        }
        else{
            toast.error('Your account is not approved!')
        }

      
    }

    const close3 =()=>{
        window.location.reload(false)
    
    }


    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
      };

      useEffect(()=>{
        
        const nc = commission - (0.1*commission)
        if(selectedOption == 'GROSS'){
            setPaymount(basicPremium)
            setCommission(comm2)
            setNetcommission(nc2)
        }
        else{
            setCommission(0.00)
            setNetcommission(0.00)
            setPaymount(Math.round(netPremium))
        }
    
      },[selectedOption])


      function generateUniqueId() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length);
            result += chars[randomIndex];
        }
        return result;
    }

    const insertLog=async(agent,activity)=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/insertLogs?activity=${activity}&agent=${agent}`,{
        method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
    });
    const data = await res.json()
    }

    const calculatePremium =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculateExtension?insuredItem=${insuredItemcode}&sumInsured=${sumInsured}&capacity=${capacity}&coverPeriod=${coverPeriod}`,{
            method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
                        const data = await res.json()
                        const {premium} = data;
                        if(premium){
                            
                            setQuotetext('Calculate premium')
                            setPremium(premium)
                            setTraininglevy(0.002*premium)
                            const tl = Math.round(0.002*premium);
                            setPHCF(Math.round(0.0025*premium))
                            const ph = Math.round(0.0025*premium)
                            setBasicpremium(premium+tl+ph+stampduty)
                            setPaymount(premium+tl+ph+stampduty)
                            const com = Math.round(0.1*premium)
                            setCommission(com)
                            const netCom = Math.round(0.1*com)
                            const nc = com - netCom;
                            setNetcommission(nc)
                            setComm2(com)
                            setNetpremium((premium+tl+ph+stampduty)-nc)
                            setNc2(nc)
                            setIscalculated(true)

                            const activity = `Extension Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                            insertLog(agentCode,activity)

        
                            
                        }
                        else{


                            setQuotetext('Calculate premium')
                            toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                            const activity = `Premium calculated for product ${productName} Not found`
                            insertLog(agentCode,activity)
                        }

    }

    const resendRequest =async()=>{
            setExtendtext('Please wait')
            toast.success('Prompt sent to phone!')
            const formattedNumber =clientPhone.slice(1);
            const formattedNumber2 ="254" + mobile.slice(1);
            const ref = generateUniqueId();
            const qref = `QP${ref}`
            const uuid = uuidv4();
            const dateDone = today;
            const res2 = await Axios.post('https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a',{formattedNumber2,payAmount,reg,uuid,qref,dateDone})
            
            if(res2.data.success){
                const transaction = res2.data.transactionId
                setTransactionId(res2.data.transactionId)
                const activity = `Payment For Extension for ${proposalNo} received amount ${payAmount} - ${transaction}`
                insertLog(agentCode,activity)

                const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy2',{
                  method:"POST",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    },
                    body:JSON.stringify({productCode,utilize:0,extension:ext,stampduty,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount,PHCF,trainingLevy,commission:cmm,whtax,netCommission,netPremium,commissionRate,transaction}),
                    credentials:"include"
                })

                const dataa = await res.json()
                const {success,trans,ref} = dataa;

             
                const activity1 = `Extension for ${proposalNo} approved.`
                insertLog(agentCode,activity1)

                setExtendtext('GENERATING CERTIFICATE...')
                //production
               const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})


                //uat
              //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})
    
                if(res3.data.success){
                    insertCertificate(res3.data.certURL,res3.data.certNo)
                    setCertURL(res3.data.certURL)
                    setIscert(1)
                    const activity = `Certicate for ${reg} generated.`
                    insertLog(agentCode,activity)
                    
                }
                else{
                    setIscert(2)
                    setEmessage(res3.data.errorMessage)
                    const activity = `Certicate for ${reg} failed to generate with error `
                    insertLog(agentCode,activity)
                }

                



            }
            else{
                setPromptid(1)
                toast.error('PAYMENT NOT RECEIVED')
                setExtendtext('Resend Request')
            }

    }

    const openModule3 =async()=>{
        initiate()
        setModal3(true)
        setTimeout(() => {
           setCheckmpesa(true)
        }, 5000)
    
    }
    const close4 =()=>{
        setCheckmpesa(false)
        setModal3(false)
    }
    
    const checkMpesatransaction =async()=>{
        if(mpesaCode){
            
            setVerifytext('Verifying.....')
            
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/checkMpesa?code=${mpesaCode}&amount=${payAmount}&reg=${reg}`,{
                    method:"GET",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    }
            });
            const data = await res.json();
            const {success} = data;
            if(success){
                const activity = `Payment for extension on proposal ${proposalNo} amount ${payAmount} received`
                insertLog(agentCode,activity)
                toast.success('Payment received')
                setVerifytext('VERIFY')
                setModal3(false)
                generateCertificate()
            }
            else{
                toast.error('No transaction with the given transaction number')
                setVerifytext('VERIFY')
            }
        }
    
    
    }

      const generateCertificate =async()=>{
            setExtendtext('PLEASE WAIT...')

           

            const activity1 = `Extension payment for proposal ${selectedProposal} C2B Confirmed`
            insertLog(agentCode,activity1)


        
                const comm = Math.round(0.1*premiumAmount)
                 const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy2',{
               method:"POST",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    },
                body:JSON.stringify({productCode,utilize:0,extension:ext,stampduty,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount,PHCF,trainingLevy,commission:cmm,whtax,netCommission,netPremium,commissionRate}),
                credentials:"include"
                })
                
                const activity = `Extension for proposal ${selectedProposal} approved`
                insertLog(agentCode,activity)
                      
                setExtendtext('GENERATING CERTIFICATE...')

                //production
                const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})

                //uat
               //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})
                
                
                const res4 = await fetch(`https://digitalapi.definiteassurance.com/api/processMpesa?code=${mpesaCode}`,{
                    method:"GET",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    }
                });
    
                if(res3.data.success){
                    insertCertificate(res3.data.certURL,res3.data.certNo)
                    setCertURL(res3.data.certURL)
                    const activity = `Certificate for ${reg} generated.`
                    insertLog(agentCode,activity)
                    setTimeout(() => {
                        setIscert(1)
                    }, 3000); 
                    
                    
                }
                else{
                    setIscert(2)
                   setEmessage(res3.data.errorMessage)
                    const activity = `Certificate for ${reg} failed to generate with error`
                    insertLog(agentCode,activity)
                }
            
          
           
            }


    const retryCertficate =async()=>{
                setRetrytext('Please wait...')
               const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})

                //uat
               //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,commencementUnix,commencementDate,expiryUnix,expiryDate,sumInsured,capacity,tonnage:0})
                
                if(res3.data.success){
                    setRetrytext('Retry')
                    insertCertificate(res3.data.certURL,res3.data.certNo)
                    setCertURL(res3.data.certURL)
                    const activity = `Certificate for ${reg} generated.`
                    insertLog(agentCode,activity)
                    setTimeout(() => {
                        setIscert(1)
                    }, 3000); 
                    
                    
                }
                else{
                    setRetrytext('Retry')
                    setIscert(2)
                   setEmessage(res3.data.errorMessage)
                   insertCertificateError(res3.data.errorMessage)
                    const activity = `Certificate for ${reg} failed to generate with error ${res3.data.errorMessage}`
                    insertLog(agentCode,activity)
                }

    }

    const initiate=async()=>{
         const comm = Math.round(0.1*premiumAmount)
                    setCmm(comm)
                    setExtendtext('PLEASE WAIT....')
                    const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy',{
                       method:"POST",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    },
                        body:JSON.stringify({clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount:basicPremium,PHCF,trainingLevy,commission,whtax,netCommission,netPremium,commissionRate}),
                        credentials:"include"
                    })
        
                    const data = await res.json();
                    const {extension,IOID } = data;
                    setExt(extension)
                    setInsuredSchedule(IOID)
                    const activity = `Extension for ${selectedProposal} initiated!`
                    insertLog(agentCode,activity)
    }

      const extendPolicy =async()=>{

            if(paymentMode == 0 && utilize == 0){
                if(mobile !== ''){
                    const comm = Math.round(0.1*premiumAmount)
                    setCmm(comm)
                    setExtendtext('PLEASE WAIT....')
                    const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy',{
                       method:"POST",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    },
                        body:JSON.stringify({clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount:basicPremium,PHCF,trainingLevy,commission,whtax,netCommission,netPremium,commissionRate}),
                        credentials:"include"
                    })
        
                    const data = await res.json();
                    const {extension,IOID } = data;
                    setExt(extension)
                    setInsuredSchedule(IOID)
                    const activity = `Extension for ${selectedProposal} initiated!`
                    insertLog(agentCode,activity)
                    
                    if(data.success){
                        toast.success('Prompt sent to phone!')
                        const formattedNumber =clientPhone.slice(1);
                        const formattedNumber2 ="254" + mobile.slice(1);
                        const ref = generateUniqueId();
                        const qref = `QP${ref}`
                        const uuid = uuidv4();
                        const dateDone = today;
                         setPromptid(3)
                        const res2 = await Axios.post('https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a',{formattedNumber2,payAmount,reg,uuid,qref,dateDone})
                        
                        if(res2.data.success){
                            const transaction = res2.data.transactionId
                            setTransactionId(res2.data.transactionId)
                            const activity = `Payment on Extension for ${selectedProposal} kes.${payAmount} received - ${transaction}`
                            insertLog(agentCode,activity)
                            const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy2',{
                                method:"POST",
                                headers:{
                                'Authorization': `Basic ${credentials}`,
                                'Content-Type': "application/json"
                                },
                                body:JSON.stringify({productCode,utilize:0,extension,stampduty,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount,PHCF,trainingLevy,commission:comm,whtax,netCommission,netPremium,commissionRate,transaction}),
                                credentials:"include"
                            })
                             const dataa = await res.json()
                            const {success,trans,ref} = dataa;

                            
                         

                            const activity1 = `Extension for ${selectedProposal} approved!`
                            insertLog(agentCode,activity1)

                            setExtendtext('GENERATING CERTIFICATE...')
                            
                            //production
                            const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,insuredOID,dateDone,selectedItem: insuredItemcode,proposalOID:selectedProposal,coverType:optionCode,clientName:client,policyNumber:policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName:modelCode,engineNumber:engine,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage:0,iraNumber})

                            //uat
                            //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,insuredOID,dateDone,selectedItem: insuredItemcode,proposalOID:selectedProposal,coverType:optionCode,clientName:client,policyNumber:policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName:modelCode,engineNumber:engine,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage:0,iraNumber})
                
                            if(res3.data.success){
                                insertCertificate(res3.data.certURL,res3.data.certNo)
                                setCertURL(res3.data.certURL)
                                setIscert(1)
                                const activity = `Certificate for ${reg} generated`
                                insertLog(agentCode,activity)
                                
                            }
                            else{
                                setIscert(2)
                                setEmessage(res3.data.errorMessage)
                                
                                const activity = `Certificate for ${reg} failed to generate with error`
                                insertLog(agentCode,activity)
                            }

                            

                            
                           
                        }



                        else{
                            setPromptid(1)
                            toast.error('PAYMENT NOT RECEIVED')
                            setExtendtext('Resend Request')
                        }
    
                    }
                    else{
                        setExtendtext('EXTEND POLICY')
                        toast.error('SOMETHING WENT WRONG')
                    }
    
                }
                else{
                    toast.error('Please enter Mpesa number!')
                }

            }
            else if(paymentMode == 1){
                if(payAmount > walletBallance){
                     const bal = payAmount - walletBallance;
                    toast.error(`INSUFFICIENT BALANCE. TOP UP KES.${formatter(bal)} TO PROCEED`)
                }
                else{
                    const comm = Math.round(0.1*premiumAmount)
                    setExtendtext('PLEASE WAIT....')
                    const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy',{
                        method:"POST",
                        headers:{
                        'Authorization': `Basic ${credentials}`,
                        'Content-Type': "application/json"
                        },
                        body:JSON.stringify({clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount:basicPremium,PHCF,trainingLevy,commission,whtax,netCommission,netPremium,commissionRate}),
                        credentials:"include"
                    })
                    
                    const data = await res.json();
                    const {extension,IOID} = data;
                    if(data.success){
                        toast.success('Deducting from wallet...')
                        const formattedNumber =clientPhone.slice(1);
                        const formattedNumber2 ="254" + mobile.slice(1);
                        const ref = generateUniqueId();
                        const qref = `QP${ref}`
                        const uuid = uuidv4();
                        const dateDone = today;
                        const newBalance = walletBallance - payAmount
                        const res2 = await Axios.post('https://sms.definiteassurance.com/webhook/04a58cac-a6b4-4bde-883a-b364f32d9ae9',{formattedNumber2,payAmount,newBalance,reg,uuid,qref,dateDone,walletNo})
                        if(res2.data.success){
                            const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy2',{
                               method:"POST",
                                headers:{
                                'Authorization': `Basic ${credentials}`,
                                'Content-Type': "application/json"
                                },
                                body:JSON.stringify({productCode,utilize:0,extension,stampduty,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount,PHCF,trainingLevy,commission:comm,whtax,netCommission,netPremium,commissionRate}),
                                credentials:"include"
                            })


                            setExtendtext('GENERATING CERTIFICATE...')
                            const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,insuredOID,dateDone,selectedItem: insuredItemcode,proposalOID:selectedProposal,coverType:optionCode,clientName:client,policyNumber:policyNumber,commencementUnix:extensionStartdate,commencementDate,expiryUnix:extesnionExpirydate,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName:modelCode,engineNumber:engine,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
                
                            if(res3.data.success){
                                insertCertificate(res3.data.certURL,res3.data.certNo)
                                setCertURL(res3.data.certURL)
                                setIscert(1)
                                
                            }
                            else{
                                setIscert(2)
                                setEmessage(res3.data.errorMessage)
                            }
                        }
                        else{
                            toast.error('PAYMENT NOT RECEIVED')
                            setExtendtext('EXTEND POLICY')
                        }
    
                    }
                    else{
                        setExtendtext('EXTEND POLICY')
                        toast.error('SOMETHING WENT WRONG')
                    }

                }


            }

            else if(utilize == 1){

                 if(payAmount > availableCommission){
                    const bal = payAmount - availableCommission;
                    toast.error(`INSUFFICIENT COMMISSION BALANCE AVAILABLE. TOP UP ${bal} TO PROCEED`)
                }
                else{
                    const comm = Math.round(0.1*premiumAmount)
                    setExtendtext('PLEASE WAIT....')
                    const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy',{
                       method:"POST",
                        headers:{
                        'Authorization': `Basic ${credentials}`,
                        'Content-Type': "application/json"
                        },
                        body:JSON.stringify({productCode,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount:basicPremium,PHCF,trainingLevy,commission,whtax,netCommission,netPremium,commissionRate}),
                        credentials:"include"
                    })
                   
                    const data = await res.json();
                    const {extension,IOID} = data;
                    if(data.success){
                        toast.success('LOADING...')
                        const formattedNumber =clientPhone.slice(1);
                        const formattedNumber2 ="254" + mobile.slice(1);
                        const ref = generateUniqueId();
                        const qref = `QP${ref}`
                        const uuid = uuidv4();
                        const dateDone = today;
                        const newBalance = walletBallance - payAmount
                     
                            const res = await fetch('https://digitalapi.definiteassurance.com/api/extendPolicy2',{
                               method:"POST",
                                headers:{
                                'Authorization': `Basic ${credentials}`,
                                'Content-Type': "application/json"
                                },
                                body:JSON.stringify({productCode,utilize:1,extension,stampduty,clientCode,agentCode,selectedProposal,today,policyNumber,payAmount,extensionStartdate:commencementUnix,extesnionExpirydate:expiryUnix,sumInsured,premiumAmount,PHCF,trainingLevy,commission,whtax,netCommission,netPremium,commissionRate}),
                                credentials:"include"
                            })


                            setExtendtext('GENERATING CERTIFICATE...')
                            const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID,insuredOID,dateDone,selectedItem: insuredItemcode,proposalOID:selectedProposal,coverType:optionCode,clientName:client,policyNumber:policyNumber,commencementUnix:extensionStartdate,commencementDate,expiryUnix:extesnionExpirydate,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName:modelCode,engineNumber:engine,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
                
                            if(res3.data.success){
                                insertCertificate(res3.data.certURL,res3.data.certNo)
                                setCertURL(res3.data.certURL)
                                setIscert(1)
                                
                            }
                            else{
                                setIscert(2)
                                setEmessage(res3.data.errorMessage)
                            }
                
    
                    }
                    else{
                        setExtendtext('EXTEND POLICY')
                        toast.error('SOMETHING WENT WRONG')
                    }
                }
            }

            

           
      }
  
    

useEffect(()=>{
    const searchPolicy =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/searchPolicy?agent=${agentCode}&search=${search}`,{
             method:"GET",
                    headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                    }
        })
        const data = await res.json()
        setPolicies(data)
    }

    if(search && agentCode){
        searchPolicy();
    }
},[search,agentCode])

function formatDateToMilliseconds(input) {
    if (typeof input === 'string') {
        // For ISO string, create Date object and get time
        return new Date(input).getTime();
    }
    else if (input instanceof Date) {
        // For Date object, directly get time
        return input.getTime();
    }
    
    throw new Error('Invalid input: Expected ISO String or Date Object');
}
function formatDate2(inputDate) {
    const date = new Date(inputDate);
    
    // Get day, month, year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    // Get hours and minutes in 12-hour format
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}.${minutes}${ampm}`;
  }


  const finish=()=>{
    window.location.reload(false)
  }

  const handleChange = (e) => {
    setPaymentmode(e.target.checked ? 1 : 0);
  };

  const handleChange2 = (e) => {
    setUtilize(e.target.checked ? 1 : 0);
  };

  useEffect(()=>{
  
      if(utilize == 1){
          setIsmpesa(false)
      }
      if(utilize == 0){
          setIsmpesa(true)
      }
  
  },[utilize])
  
  useEffect(()=>{
  
      if(paymentMode == 1){
          setIsmpesa(false)
      }
      if(paymentMode == 0){
          setIsmpesa(true)
      }
  
  },[paymentMode])

  const insertCertificate=async(certLink,certNo)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificate',{
       method:"POST",
        headers:{
        'Authorization': `Basic ${credentials}`,
        'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID:selectedProposal,insuredOID,expiryUnix,commencementUnix,certNo,certLink,today})
    })

    const data = await res.json()
}


const insertCertificateError=async(errorMes)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificateerror',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID:selectedProposal,insuredOID,expiryUnix,commencementUnix,errorMes,today})
    })

    const data = await res.json()
}
  return (
    <div>
        <div className="page-content">
            <ToastContainer />
            <Breadcrumbs title="Definite Assurance" breadcrumbItem="Active Policies" />
            <Card className="mini-stats-wid">
                <CardBody>
                    <h4>SEARCH / FILTER</h4>
                 

                    <div className="filter">
                        <div className="searchContainer">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search by Registration/Client Name" onChange={(e)=>{setSearch(e.target.value)}}>
                                <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search by Registration/Name" />
                            </FloatingLabel>
                        </div>
                        <div className="filterbydate">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="From" onChange={handleDateChange}>
                                <Form.Control  className='inputSearch'   type="datetime-local" placeholder="From" />
                            </FloatingLabel>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="End" onChange={handleDateChange2}>
                                <Form.Control  className='inputSearch'   type="datetime-local" placeholder="End" />
                            </FloatingLabel>

                        </div>
                    </div>

                    <div className="table-responsive">


                        <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Policy No.</th>
                            <th scope="col">Date Done</th>
                            <th scope="col">Client</th>
                            <th scope="col">Product</th>
                            <th scope="col">Registration</th>
                            <th scope="col">Commencement Date</th>
                            <th scope="col">Expiry Date</th>
                            <th scope="col">Gross Premium(KES)</th>
                            <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPolicies.map((val, index) => {
                            // Calculate the correct index based on current page
                            const globalIndex = indexOfFirstRow + index;

                            if(startDate == '' && endDate == ''){
                                return (
                                    <tr key={val.OID}>
                                    <td>{index + 1}</td>
                                    <td ><button style={{color:'green'}} className="tableButton" value={val.OID} onClick={getDetails}>{val.PolicyNo}</button></td>
                                    <td>{formateDateISO(val.DateDone)}</td>
                                   
                                    <td>{val.Dealer_name}</td>
                                    <td>{val.ProductDescription}</td>
                                    <td>{val.Narration}</td>
                                    <td>{formateDateISO(val.CommencementDate)}</td>
                                    <td>{formateDateISO(val.ExpiryDate)}</td>
                                    <td>{formatter(val.GrossPremium)}</td>
                                    <td ><button className="tableButton2" value={val.OID} onClick={getDetails2}>Extend</button></td>
                                    </tr>
                                );

                            }
                            else if(startDate !== '' && endDate == ''){
                                return (
                                    <tr key={val.OID}>
                                    <td>{index + 1}</td>
                                    <td ><button className="tableButton" value={val.OID} onClick={getDetails}>{val.PolicyNo}</button></td>
                                    <td>{formateDateISO(val.DateDone)}</td>
                                   
                                    <td>{val.Dealer_name}</td>
                                    <td>{val.ProductDescription}</td>
                                    <td>{val.Narration}</td>
                                    <td>{formateDateISO(val.CommencementDate)}</td>
                                    <td>{formateDateISO(val.ExpiryDate)}</td>
                                    <td>{formatter(val.GrossPremium)}</td>
                                     <td ><button className="tableButton2" value={val.OID} onClick={getDetails2}>Extend</button></td>
                                    </tr>
                                );

                            }
                            else if(formatDateToMilliseconds(val.DateDone) > startDate && formatDateToMilliseconds(val.DateDone) < endDate ){
                                return (
                                    <tr key={val.OID}>
                                   <td>{index + 1}</td>
                                    <td ><button className="tableButton" value={val.OID} onClick={getDetails}>{val.PolicyNo}</button></td>
                                    <td>{formateDateISO(val.DateDone)}</td>
                                   
                                    <td>{val.Dealer_name}</td>
                                    <td>{val.ProductDescription}</td>
                                    <td>{val.Narration}</td>
                                    <td>{formateDateISO(val.CommencementDate)}</td>
                                    <td>{formateDateISO(val.ExpiryDate)}</td>
                                    <td>{formatter(val.GrossPremium)}</td>
                                     <td ><button className="tableButton2" value={val.OID} onClick={getDetails2}>Extend</button></td>
                                    </tr>
                                );
                            }
                            
                            })}
                        </tbody>
                        </Table>

                        {/* Pagination controls */}
                        <div className="d-flex justify-content-between align-items-center">
                        <div>
                            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, policies.length)} of {policies.length} entries
                        </div>
                        <div>
                            <button 
                            className="btn btn-sm btn-outline-primary mx-1"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            >
                            Previous
                            </button>
                            
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                            <button
                                key={page}
                                className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                            ))}
                            
                            <button 
                            className="btn btn-sm btn-outline-primary mx-1"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            >
                            Next
                            </button>
                        </div>
                        </div>

        </div>
                </CardBody>
            </Card>
        </div>

        <Modal isOpen={modal} size="xl">
            <ModalHeader>{proposalNo}</ModalHeader>
            <div className="modalContainer">
                <div className="modalTables">
                    <div className="modalTable">
                        <h5>RISK DETAILS</h5>

                        <div className="table-responsive" id="dataTable" >
                            <Table striped bordered hover>

                                <thead>
                                    <tr>
                                        <th scope="col">ITEM</th>
                                        <th scope="col">DESCRIPTION</th>                         
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr>
                                            <td>CLIENT</td>
                                            <td><strong>{client}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>PRODUCT</td>
                                            <td><strong>{productName}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>POLICY NUMBER</td>
                                            <td><strong>{policyNumber}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>COVER OPTION</td>
                                            <td><strong>{optionName}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>PERIOD OF COVER</td>
                                            <td><strong>{coverPeriod}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>COMMENCEMENT DATE</td>
                                            <td><strong>{formateDateISO(commence1)}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>EXPIRY DATE</td>
                                            <td><strong>{formateDateISO(expiry1)}</strong></td>
                                        </tr>
                                
                                </tbody>
                            </Table>
                        </div>

                        <div className="modalButtons">
                            <Button className="mButton" color='success' onClick={toggle}>EXTEND</Button>
                            <Button style={{marginLeft:'2%'}} className="mButton" color='danger' onClick={cancelPolicy}>CANCEL POLICY</Button>
                        </div>

                    </div>

                    <div className="modalTable">
                        <h5>INSURED ITEM</h5>

                        <div className="table-responsive" id="dataTable" >
                            <Table striped bordered hover>

                                <thead>
                                    <tr>
                                        <th scope="col">ITEM</th>
                                        <th scope="col">DESCRIPTION</th>                         
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr>
                                            <td>INSURED ITEM</td>
                                            <td><strong>{insuredItem}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>PREMIUM AMOUNT</td>
                                            <td><strong>KES. {(premiumAmount)}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>COMMISSION</td>
                                            <td><strong>KES. {(commission)}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>REGISTRATION</td>
                                            <td><strong>{reg}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>MAKE</td>
                                            <td><strong>{makeName}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>MODEL</td>
                                            <td><strong>{modelCode}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>YEAR OF MANUFACTURE</td>
                                            <td><strong>{yom}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>TONNAGE</td>
                                            <td><strong>{tonnage}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>CHASIS NUMBER</td>
                                            <td><strong>{chassis}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>ENGINE NUMBER</td>
                                            <td><strong>{engine}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>CAPACITY</td>
                                            <td><strong>{capacity}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>SUM INSURED</td>
                                            <td><strong>KES. {(sumInsured)}</strong></td>
                                        </tr>
                                
                                </tbody>
                            </Table>
                        </div>

                    </div>

                </div>
                <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={()=>{setModal(false)}}>CLOSE</p>
            </div>
        </Modal>

        <Modal isOpen={modal2} toggle={toggle}>
            <ModalHeader>EXTEND {proposalNo}</ModalHeader>
            <div className="modalContainer">
              
            {isCert == 0 &&
            <>
              
      
      
              <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="PAYMENT INTERVAL" onChange={(e)=>{setCoverperiod(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>SELECT PAYMENT INTERVAL</option>
                                    {(productCode==4638 || productCode == 3587 || productCode == 3586) &&
                                        <>
                                            <option value="Week">Weekly</option>
                                            <option value="Fortnight">Fortnight</option>
                                            <option value="Monthly">Monthly</option>
                                            <option value="Annually">Annually</option>
                                            <option value="3Installments">Three Installments</option>
                                            <option value="6Installments">Six Installments</option>
                                            <option value="10Installments">Ten Installments</option>
                                        </>
                                    
                                    }
                                    {(productCode!==4638 && productCode !==3587) &&
                                    <>
                                        <option value="Annually">Annually</option>
                                      <option value="2installments">Two Installments</option>
                                    </>

                                    }
                                </Form.Select>
                            </FloatingLabel>

           <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Commencemence date" onChange={handleDateChange3}>
               <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Commcencement date" />
           </FloatingLabel>

           <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Expiry date" >
               <Form.Control  className='inputSearch'   type="text" value={formatDate2(expiryUnix)} disabled />
           </FloatingLabel>
           {checkingStatus == 1 &&
            <p>Checking double insurance...</p>
           }
           {(checkingStatus == 2 && !doubleInsurancestatus) &&
            <p style={{color:'green'}}>No double insurance.</p>
           }
            {doubleInsurancestatus &&
                <p style={{color:'red'}}>{doubleinsuranceMessage}</p>
            }
            {!doubleInsurancestatus &&
                 <Button color="success" onClick={calculatePremium}>{quoteText}</Button>
            }
          

       <br />

       {isCalculated &&

       <>
        
       {/* <div style={{marginTop:'10px'}}>
           <label>
               <input
               type="radio"
               value="GROSS"
               
               checked={selectedOption === 'GROSS'}
               onChange={handleOptionChange}
               style={{marginRight:'5px'}}
               />
               GROSS PAYMENT
           </label>

           <label style={{marginLeft:'10px'}}>
               <input
               type="radio"
               value="NET"
               checked={selectedOption === 'NET'}
               onChange={handleOptionChange}
               style={{marginRight:'5px'}}
               />
               NET PAYMENT
           </label>

           
           </div> */}

           <hr />
          
           <div className="checkboxes">
                {/* <label className="checkboxLabel1">
                    <input 
                    type="checkbox" 
                    checked={paymentMode === 1}
                    onChange={handleChange}
                    style={{marginRight:'3px'}}
                    />
                    PAY FROM WALLET
                </label> */}


                {/* <label className="checkboxLabel2">
                    <input 
                    type="checkbox" 
                    checked={utilize === 1}
                    onChange={handleChange2}
                    style={{marginRight:'3px'}}
                    />
                    UTILIZE COMMISSION
                </label> */}

                </div>
           <h5>PREMIUM: KES. {formatter(payAmount)}</h5>
           {/* <p>Gross commission: {commission}</p>
           <p>Net Premium: {netPremium}</p>
           <p>Net Commission: {netCommission}</p> */}
           <hr />

           {isMpesa &&
                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="MPESA NUMBER" onChange={(e)=>{setMobile(e.target.value)}} >
                    <Form.Control  className='inputSearch'   type="text" value={mobile} placeholder="MPESA NUMBER" />
                </FloatingLabel>
           
           
           }
           {!isMpesa &&
           <>
             <p>AVAILABLE BALANCE: KES. {walletBallance}</p>
             <p>AVAILABLE COMMISSION: KES. {availableCommission}</p>
            </>
           
           }

        {(promptID == 0 || promptID == 3) &&
           <Button className="mButton" color="success" onClick={extendPolicy}>{extendText}</Button>
        
        }
        {promptID == 1 &&
            <Button color="success" className="quoteButton2" onClick={resendRequest} >{extendText}</Button>
        
        }
            {/* {promptID == 0 &&
                <>  
            <p style={{textAlign:'center',marginTop:'4%',marginBottom:'2%'}}>___________OR__________</p>
            <div className="mpesaSteps">
                <p>1. GO TO  MPESA TOOLKIT</p>
                <p>2. SELECT LIPA NA MPESA</p>
                <p>3. SELECT PAYBILL</p>
                <p>4. ENTER PAYBILL NUMBER <strong>200300</strong></p>
                <p>5. ENTER ACCOUNT <strong>{reg}</strong></p>
                <p>6. ENTER MPESA PIN AND COMPLETE</p>
                
                <p onClick={openModule3} style={{fontSize:'17px',marginTop:'5%',fontWeight:'bold',color:'#0f4f48',cursor:"pointer "}}>ALREADY PAID? CLICK HERE</p>
            </div> 
                </>
            } */}



           
           
       </>

       
       }
       </>    
            }

           
            
            {isCert == 1 &&
                <>
                <a style={{backgroundColor:'green',width:'100%',color:'white',padding:'10px',borderRadius:'5px',marginBottom:'20px'}} href={certURL} target="_blank" rel="noreferrer">DONWLOAD CERTIFICATE</a>
                    
                <hr />
                </>
            
            }
            {isCert == 2 &&
            <>
                <p style={{color:'red'}}>ERROR: {eMessage}</p>
                <Button color="success" onClick={retryCertficate}>{retryText}</Button>
            </>
            
            }
            <div className="">
                 <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={close3}>CLOSE</p>
            </div>
           
            </div>
        </Modal>

         <Modal isOpen={modal3}>
                    <ModalHeader>Confirm Payment</ModalHeader>
                    <div className="modalContainer">
                        {!checkMpesa &&
                            <p style={{textAlign:'center'}}>Checking payment please wait...</p>
                        }
                        {checkMpesa &&
                            <>
                                <p style={{color:'red'}}>Kindly enter the transaction code below</p>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Transaction code" onChange={(e)=>{setMpesacode(e.target.value)}} >
                                    <Form.Control  className='inputSearch' type="text" placeholder="Transaction code" />
                                </FloatingLabel>
                                <Button color="success" onClick={checkMpesatransaction}>{verifyText}</Button>
                               
                            </>
                        
                        }
                         <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={close4}>CLOSE</p>
                    </div>
                </Modal>
    </div>
  )
}
